"use client";

// import { PresetSelector } from "@/components/preset-selector";

export function Header(props: any) {
  return props.isNewLayout ? (
    <div className="flex flex-shrink-0 flex-col lg:flex-row p-4 bg-white">
      <div className="flex flex-col items-center lg:items-center lg:justify-center lg:flex-grow">
        <h1
          className="font-semibold text-center lg:pt-[100px]"
          style={{ fontSize: "30px" }}
        >
          VoiceSights AI
        </h1>
      </div>
    </div>
  ) : (
    <div className="flex flex-shrink-0 flex-col lg:flex-row p-4 border-l border-r border-t border-b rounded-t-md bg-white">
      <div className="flex flex-col items-center lg:items-center lg:justify-center lg:flex-grow">
        <h2 className="text-lg font-semibold text-center">VoiceSights AI</h2>
      </div>
    </div>
  );
  // <div className="flex flex-row items-center justify-between sm:justify-end space-x-2 mt-2 lg:mt-0">
  // {/* <div className="flex flex-row items-center space-x-2"> */}
  //   {/* <PresetSelector /> */}
  //  {/* <PresetSave />*/}
  //  {/* <PresetShare />*/}
  //   {/* <CodeViewer />*/}
  //  {/* </div> */}
  // {/* </div> */}
}
